import configureAxios from 'configure/axios';

const axios = configureAxios();

export const getAll = (userId) => axios.get(`payment_methods/`, { params: { user_profile: userId } });
export const setDefault = (id) => axios.post(`payment_methods/${id}/set_default/`);
export const create = (attr) => axios.post(`payment_methods/`, attr);
export const destroy = (userId, cardId) => axios.delete(`users/${userId}/card_info/?card_id=${cardId}`);
